<a *ngIf="external; else localLink" [href]="url" class="links-block account-menu__user bg-card-new card-radius-x1">
    <div class="account-menu__user-info">
        <div class="account-menu__user-name" style="font: 0.8rem"  *ngIf="title &&title[lang]?.length">{{title[lang]}}</div>
        <div class="account-menu__user-email"style="font: 0.7rem" *ngIf="subtitle &&subtitle[lang]?.length">{{subtitle[lang]}}</div>
    </div>
    <div [class]="rtl?'mr-auto pr-3':'ml-auto pl-3'"  style="height: 1.5rem; opacity: 0.6;">
        <mat-icon *ngIf="!rtl">chevron_right</mat-icon>
        <mat-icon *ngIf="rtl">chevron_left</mat-icon>
    </div>
</a>
<ng-template #localLink>
<a [routerLink]="url" class="links-block account-menu__user bg-card-new card-radius-x1">
    <div class="account-menu__user-info">
        <div class="account-menu__user-name" style="font: 0.8rem"  *ngIf="title &&title[lang]?.length">{{title[lang]}}</div>
        <div class="account-menu__user-email" style="font: 0.7rem" *ngIf="subtitle &&subtitle[lang]?.length">{{subtitle[lang]}}</div>
    </div>
    <div [class]="rtl?'mr-auto pr-3':'ml-auto pl-3'" style="height: 1.5rem; opacity: 0.6;">
        <mat-icon *ngIf="!rtl">chevron_right</mat-icon>
        <mat-icon *ngIf="rtl">chevron_left</mat-icon>
    </div>
</a>
</ng-template>